import React, { useState } from 'react';
import '../../quoter/styleQuoters/styleTableQuoter.css'
import '../../quoter/styleQuoterClinicMovil/styleTableQuoterMobile.css'
import {Col, Button} from 'reactstrap';
import { cedimi } from '../../../constant/globalConstantsTypeClients';

export const TableQuoter = (props) => {

    const {
        listQuoterTest,
        deleteExamProfile,
        number_format,
        handleCheckUrgent,
        handleViewExamsProfile, viewQuoter
    } = props;

    let url = localStorage.getItem('url_helen')


    return (
        <div className={`quoter-table-container ${viewQuoter ? "table-disabled" : ""}`}>
            <div className="quoter-table-header">

                <div>CÓDIGO</div>
                <div>EXAMEN / PERFIL</div>
                <div>TIEMPO ENTREGA</div>
                <div>COSTO</div>
                <div>{url === cedimi ? "Guardia" : "¿Urgente?"}</div>
                <div>ACCIONES</div>

            </div>



            <div className="quoter-table-body">

                {listQuoterTest?.map((item, index) => (

                    <div
                        key={`${item.id_exam}-${item.id_profile}-${index}`}
                        className={`quoter-table-row ${item?.is_urgent ? "row-urgent" : ""}`}
                    >

                        <div className="col-code-quoter">
                            {item.code}
                        </div>

                        <div className="col-exam-quoter">

                          <div className="exam-name-quoter">
                            {item?.name ?? "---"}

                            {/* {item?.id_profile !== null && (
                                <button
                                    type="button"
                                    className="btn-profile-exams-quoter-clinics"
                                    onClick={() => handleViewExamsProfile(item?.id_profile)}
                                    title="Ver exámenes del perfil"
                                >
                                    <i className="icofont icofont-laboratory"></i>
                                </button>
                            )} */}
                        </div>
                            

                            {/* <small className="exam-abbreviation-quoter">
                                {item.abbreviation}
                            </small> */}

                        </div>

                        <div className="col-time-quoter">

                            <span className="delivery-badge-quoter">
                                <i className="fa fa-clock-o"></i>

                                {item.delivery_time ?? "N/A"}
                            </span>

                        </div>

                        <div className="col-cost-quoter">

                            <span className="price-badge">
                                 {item?.config_iva
                                ? item?.id_agreement === null || item?.id_agreement === 0
                                    ? `$ ${number_format(item?.price.toFixed(2))}`
                                    : `$ ${number_format(item?.price_Agremment.toFixed(2))}`
                                : item?.id_agreement !== null && item?.id_agreement !== 0
                                    ? `$ ${number_format((item?.price_Agremment * 1.16).toFixed(2))}`
                                    : `$ ${number_format((item?.price * 1.16).toFixed(2))}`}

                            </span>

                        </div>

                        <div className="col-guard-quoter">
                            <label
                                className="switch-urgent"
                                title={item?.is_urgent ? "Urgente" : "Normal"}
                            >
                                <input
                                    id={`urgent-${index}`}
                                    type="checkbox"
                                    checked={item?.is_urgent}
                                    onChange={(e) => handleCheckUrgent(index, e)}
                                />
                                <span className="slider-urgent"></span>
                            </label>
                        </div>

                        <div className="col-actions-quoter">
                            {item?.id_profile !== null && (
                                <button
                                    className="btn-action-quoter studies"
                                    onClick={() => handleViewExamsProfile(item?.id_profile)}
                                    title="Ver exámenes del perfil"
                                >
                                    <i className="fa fa-flask"></i>
                                </button>
                            )}

                            <button
                                className="btn-action-quoter delete"
                                title="Eliminar estudio"
                                onClick={(e) =>
                                    deleteExamProfile(
                                        e,
                                        item.id_exam,
                                        item.id_profile
                                    )
                                }
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                            

                        </div>

                    </div>

                ))}

            </div>
            {
                listQuoterTest?.length === 0 && (
                    <Col sm="12" className="empty-quoter-container" >

                        <div className="floating-circles">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        <i className="fa fa-receipt pos-empty-icon"></i> <br /><br /><br /><br /><br /><br />

                        <i className="icofont icofont-document-search pos-empty-icon-a"></i> <br /><br />


                        <h6 className="pos-empty-title">
                            Sin estudios seleccionados
                        </h6>
                    </Col>
                )
            }



        </div>
    );
};


